import { render } from "./Signin.vue?vue&type=template&id=3886e47c"
import script from "./Signin.vue?vue&type=script&lang=js"
export * from "./Signin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__